// import SignatureCanvas from 'react-signature-canvas';
import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  getkyc,
  updatekyc,
  uploadFile,
  sendEmailNotification,
  generateShareLink,
  notifyEmail,
  frontEndBaseURL,
  createNotification,
  generateFormToken,
  makeTinyUrl,
} from '../../../API/Api';
import { toast } from 'react-toastify';
import FormStatusEnum from '../../../data/FormStatusEnum';
import CountryList from './CountryList';
import ConnectedOrBeneficialParty from './ConnectedOrBeneficialParty';
import CounterpartyManager from './CounterpartyManager';
import Tooltip from '@mui/material/Tooltip';
import { jwtDecode } from 'jwt-decode';
import { DateTime } from 'luxon';
import Modal from '../../shared/Modal';
import { TokenContext } from '../../../App';
import CustomTooltip from './CustomTooltip';
import Loading from '../../shared/Loading';

const _EntityDetails = ({
  companyName,
  showSubmitButton,
  readOnly,
  currentUrl,
  clientFormId,
  maxPage,
  token,
  formAuthority,
}) => {
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [mandatoryFieldError, setMandatoryFieldError] = useState({
    name: '',
    uenNumber: '',
    incorporationCountry: '',
    incorporationDate: '',
    registeredAddress: '',
    contactNumber: '',
    email: '',
    //  taxResidenceCountry: 'SG',
    formOfEntity: '',
    incorporationCountry: '',
    acraBusinessProfile: '',
    companyConstitution: '',
    businessRelationShip: '',
    governmentLinkedClient: '',
    listedInRule84: '',
  });
  const [mandatoryConnectedFieldError, setMandatoryConnectedFieldError] = useState([]); // name: '', address: '', identificationNumber: ''
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [formData, setFormData] = useState({
    _id: clientFormId,
    name: '',
    uenNumber: '',
    incorporationDate: '',
    registeredAddress: '',
    contactNumber: '',
    email: '',
    formStatus: '',
    connectedParty: [],
    // [{
    //   relationship: '', name: '', gender: '', address: '', identificationNumber: '', identificationDocumentURL: '', identificationExpiryDate: '',
    //   birthDate: '', address: '', email: '', residenceStatus: '', nationality: '',
    //
    //   pepPerson: ' - No', pepPersonCountryOrOrganisation: '', pepPersonPublicFunctionNature: '', pepPersonRoleFrom: '', pepPersonRoleTo: '',  identificationDocumentLink: '', identificationExpiryDate: '',
    //   pepAssociate: ' - No', pepAssociateRelationship: '',  pepAssociateName: '', pepAssociateCountryOrOrganisation: '', pepAssociatePublicFunctionNature: '',pepAssociateRoleFrom: '', pepAssociateRoleTo: '',
    //   pepFamily: ' - No', pepFamilyRelationship: '', pepFamilyName: '', pepFamilyCountryOrOrganisation: '', pepFamilyPublicFunctionNature: '', pepFamilyRoleFrom: '', pepFamilyRoleTo: '',
    // }],
    singaporeGovernmentEntity: '',
    listedOnStockExchange: '',
    financialInstitution: '',
    acraBusinessProfile: '',
    companyConstitution: '',
    organisationChart: '',
    formOfEntity: '',
    natureOfBusiness: '',
    sourceOfWealth: '',
    taxResidenceCountry: 'SG',
    declarationName: '',
    declarationDate: '',
    signatureUrl: '',
    accountManager: '',
    isvVideo: 'no',
    notes: '',
  });

  // const [encodedAccessToken] = useContext(TokenContext)
  const decodedToken = jwtDecode(token);
  const [loading, setLoading] = useState(true);
  // let signatureRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      // console.log('userData')
      const userData = await getkyc(clientFormId, token);
      // console.log(userData)
      // console.log('userData3')
      setFormData({
        ...userData.data?.details,
        taxResidenceCountry: userData.data?.details?.taxResidenceCountry || 'SG',
        incorporationCountry: userData.data?.details?.incorporationCountry || 'SG',
        _id: clientFormId,
        name: userData?.data?.name,
        email: userData?.data?.email,
        formStatus: userData?.data?.formStatus,
        maxPage: userData?.data?.maxPage,
        connectedParty: userData?.data?.details?.connectedParty || [],
        isvVideo: userData.data?.details?.isvVideo,
        counterparties: userData?.data?.details?.counterparties || [],
      });

      userData.data?.connectedParty?.forEach(party => {
        mandatoryConnectedFieldError.append({ name: '', address: '', identificationNumber: '', roleSelected: '' });
      });
      setMandatoryConnectedFieldError(mandatoryConnectedFieldError);
      setLoading(false);
    };
    // console.log('userData2')

    fetchData();
  }, []);

  const handleFileUpload = async (e, fileType) => {
    const { name } = e.target;
    const file = e.target.files[0];
    if (!file) {
      return;
    }

    try {
      const data = new FormData();
      data.append('file', file);
      const filename = `${fileType}_${file.name}`;

      const res = await uploadFile(data, filename, token);
      if (res) {
        setFormData(prevState => {
          const currentValue = prevState[name];

          // 如果是 organisationChart 字段，支持数组和字符串两种格式
          if (name === 'organisationChart') {
            if (Array.isArray(currentValue)) {
              // 如果已经是数组，添加到数组中
              return {
                ...prevState,
                [name]: [...currentValue, res.data.url],
              };
            } else if (currentValue) {
              // 如果已经有值但不是数组，转换为数组
              return {
                ...prevState,
                [name]: [currentValue, res.data.url],
              };
            } else {
              // 如果没有值，直接设置为字符串（保持向后兼容）
              return {
                ...prevState,
                [name]: res.data.url,
              };
            }
          } else {
            // 其他字段保持原有逻辑
            return {
              ...prevState,
              [name]: res.data.url,
            };
          }
        });
      } else {
        toast.error('Invalid file type!');
      }
    } catch (e) {
      toast.error('Invalid file type!');
    }
  };

  const handleFileRemove = async fileName => {
    if (readOnly) {
      return;
    }

    setFormData(prevState => ({
      ...prevState,
      [fileName]: '',
    }));
  };

  const handleFileRemoveFromArray = async (fileName, index) => {
    if (readOnly) {
      return;
    }

    setFormData(prevState => {
      const currentValue = prevState[fileName];
      if (Array.isArray(currentValue)) {
        const newArray = currentValue.filter((_, i) => i !== index);
        return {
          ...prevState,
          [fileName]: newArray.length === 0 ? '' : newArray,
        };
      }
      return prevState;
    });
  };

  // Counterparty 相关处理函数
  const handleInputChange = e => {
    const { name, value } = e.target;
    const newData = {
      ...formData,
      [name]: value, // name refer to 'input name' property.
    };
    setFormData(newData);

    const requiredFields = [
      'name',
      'uenNumber',
      'incorporationCountry',
      'incorporationDate',
      'registeredAddress',
      'email',
      'taxResidenceCountry',
      // "contactNumber"
      'formOfEntity',
      'acraBusinessProfile',
      'companyConstitution',
      'businessRelationShip',
      'listedInRule84',
      'identificationExpiryDate',
      'pepPerson',
      'pepAssociate',
      'pepFamily',
    ];
    // if (decodedToken.companyId == 'Inspro_Insurance') {  requiredFields.push("contactNumber") }
    if (!requiredFields.includes(name)) {
      return;
    }

    let newMandatoryFieldError = { ...mandatoryFieldError };
    if (value.trim() === '') {
      newMandatoryFieldError[name] = true;
    } else {
      newMandatoryFieldError[name] = false;
    }

    setMandatoryFieldError(newMandatoryFieldError);
  };

  // Handle counterparty changes from CounterpartyManager
  const handleCounterpartiesChange = useCallback(({ counterparties, enableCounterparties }) => {
    setFormData(prevState => ({
      ...prevState,
      counterparties,
      enableCounterparties,
    }));
  }, []);

  const handleSaveForm = async e => {
    // let signatureData = await signatureRef.current.toDataURL(); // 如有需要，可使用签名数据（base64图片）
    setLoading(true);
    const newFormData = {
      ...formData,
      maxPage: formData.maxPage || 1,
      emailSent: false,
      counterparties: formData.counterparties,
      enableCounterparties: formData.enableCounterparties || 'no',
    };
    setFormData(newFormData);

    const res = await updatekyc(newFormData, queryParams.get('formToken'));
    if (res && res.status === 200 && res.data.status) {
      setLoading(false);
      if (res.data.success) {
        toast.success('Form Saved!');
      } else {
        toast.warning('Form already saved!');
      }
      // const uuid = queryParams.get('_d');
      // if (uuid) {
      //   notifyEmail(uuid, formData);
      // }
    } else {
      setLoading(false);
      toast.error('Failed to save form');
    }
  };

  const generateFormLink = async () => {
    const formTokenData = {
      name: formData.name,
      userId: clientFormId,
      companyId: decodedToken.companyId,
    };

    // const formToken = (await generateFormToken(formTokenData)).data.accessToken;
    // const userVar = `userName=${decodedToken.name ? encrypt(decodedToken.name) : ''}&userEmail=${decodedToken.email ? encrypt(decodedToken.email) : ''}`;
    // const linkToForm = `${frontEndBaseURL}/form/kyc-aml?${userVar}&clientFormId=${clientFormId}&page=1&formToken=${formToken}`;
    const shortLinkToCopy = await generateShareLink({
      formTokenData,
      frontEndBaseURL,
      clientFormId,
    });
    // const uuid = shortLinkToCopy.data?.split('_d=')[1];
    // return `${frontEndBaseURL}/form/kyc-aml?clientFormId=${clientFormId}&page=1&formToken=${formToken}&_d=${uuid}`;
    // const shortLink = `${process.env.REACT_APP_BACKEND_URL}/kyc/kyc-aml?_d=${uuid}`;
    // return (await makeTinyUrl(shortLink)).data;
    return shortLinkToCopy.data;
  };

  const handleSendEmail = async () => {
    // const formTokenData = {
    //   name: formData.name,
    //   userId : clientFormId,
    //   companyId : decodedToken.companyId,
    // }
    // const formToken = (await generateFormToken(formTokenData)).data.accessToken;
    // const linkToForm = frontEndBaseURL + '/form/kyc-aml?clientFormId=' + clientFormId + '&page=1&formToken=' + formToken;

    const linkToForm = await generateFormLink();

    sendEmailNotification({
      email: formData.email,
      subject: 'KYC Form Invitation - iCompass',
      message: `
        <div style="max-width: 600px; margin: 0 auto; border: 2px solid #FF8C00; padding: 20px; text-align: center;">
          <h1 style="margin-bottom: 20px; text-decoration: underline;">KYC Information Request</h1>
          <p> Dear ${formData.name} (Entity) </p>
          <p> ${decodedToken.name} from ${decodedToken.companyName} has requested for you to fill in your details in order to fulfill their KYC/AML obligations.  </p>
          <p> This link is only valid for Two weeks. </p>
          <p>
            Please use the <a href= '${linkToForm} '> link </a>
            to access the form and fill in the necessary information as requested.
          </p>
          <img src="https://icompass-backend-dev-fhagh5hccpf2ebh9.southeastasia-01.azurewebsites.net/images/from_icompass" alt="iCOMPASS logo" style="display: block; margin: 20px auto; width: 200px; height: auto; max-width: 100%;">
          <p style="font-style: italic; margin-top: 20px;">Please do not reply to this email</p>
        </div> `,
    });

    const newFormData = {
      ...formData,
      emailSent: true,
      maxPage: 1,
      counterparties: formData.counterparties,
      enableCounterparties: formData.enableCounterparties || 'no',
    };
    setFormData(newFormData);
    await updatekyc(newFormData, queryParams.get('formToken'));
    toast.info(`Form saved, Email notification to ${formData.email} sent!`);
    navigate('/kyc-aml/customer-list');
  };

  const handleSubmitForm = async e => {
    // const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // setIsValidEmail(emailPattern.test(formData.email));  // Check if the entered email matches the email pattern
    //   for (const key in formData) {
    //         if (formData[key].trim() === '') {
    //             toast.info("Please fill in all fields")
    //             return
    //         }
    // }

    //1. check mandatory fields filled
    const requiredFields = [
      'name',
      'uenNumber',
      'incorporationCountry',
      'incorporationDate',
      'registeredAddress',
      'email',
      'taxResidenceCountry',
      // "contactNumber",
      'formOfEntity',
      'acraBusinessProfile',
      'companyConstitution',
      'businessRelationShip',
      'listedInRule84',
    ];
    // if (decodedToken.companyId == 'Inspro_Insurance') {  requiredFields.push("contactNumber") }

    let allRequiredFieldsFilled = true;
    let newMandatoryFieldError = { ...mandatoryFieldError };

    requiredFields.forEach(field => {
      if (!formData[field]) {
        allRequiredFieldsFilled = false;
        newMandatoryFieldError[field] = true;
      } else {
        newMandatoryFieldError[field] = false;
      }
    });
    setMandatoryFieldError(newMandatoryFieldError);

    const requiredConnectedFields = [
      'name',
      'address',
      'identificationNumber',

      'dateOfBirth',
      'nationality',
      'addressProofURL',
      'gender',
      'addressCountry',
      'identificationDocumentURL',
      'identificationExpiryDate',
      'pepPerson',
      'pepAssociate',
      'pepFamily',
    ];
    let newMandatoryConnectedFieldError = [];

    // 验证 connectedParty
    if (formData.listedInRule84 !== 'yes') {
      // 当选择 "no" 或不选择时，必须至少有一个 connectedParty
      if (formData.connectedParty.length === 0) {
        allRequiredFieldsFilled = false;
      }
    }

    // 根据 listedInRule84 的值决定验证哪些字段
    formData.connectedParty.forEach((party, partyIndex) => {
      newMandatoryConnectedFieldError.push({ name: '', address: '', identificationNumber: '', roleSelected: '' });

      if (formData.listedInRule84 === 'yes') {
        // 当 listedInRule84 为 'yes' 时，只验证 name 字段
        if (!party.name) {
          allRequiredFieldsFilled = false;
          newMandatoryConnectedFieldError[partyIndex].name = true;
        }
      } else {
        // 当 listedInRule84 不为 'yes' 时，验证所有必填字段
        requiredConnectedFields.forEach(field => {
          if (!party[field]) {
            allRequiredFieldsFilled = false;
            newMandatoryConnectedFieldError[partyIndex][field] = true;
          }
        });
        // 特殊检查：至少选择一个角色（authorisedSignatory/connectedParty/ultimateBeneficialOwner）
        if (!party.authorisedSignatory && !party.connectedParty && !party.ultimateBeneficialOwner) {
          allRequiredFieldsFilled = false;
          newMandatoryConnectedFieldError[partyIndex].roleSelected = true;
        }
      }
    });
    setMandatoryConnectedFieldError(newMandatoryConnectedFieldError);

    if (!allRequiredFieldsFilled) {
      toast.warning('Please fill in the required fields');
      return;
    }

    // 2. save to DB
    const newFormData = {
      ...formData,
      formStatus: FormStatusEnum.PENDING_RISK_ASSESSMENT_2,
      maxPage: 2,
      emailSent: false,
      counterparties: formData.counterparties,
      enableCounterparties: formData.enableCounterparties || 'no',
    };
    setFormData(newFormData);
    toast.info('Form Submitted!');
    // console.log('pre-update')
    await updatekyc(newFormData, queryParams.get('formToken'));

    // console.log('pre-notification')
    await createNotification({
      type: 'KYC',
      text: `${newFormData.name} status has changed to Pending Risk Assessment`,
      date: DateTime.now().toFormat('dd-MM-yyyy HH:mm:ss'),
    });
    // console.log('post-notification')

    if (currentUrl !== '/form/kyc-aml') {
      window.location.href = `/kyc-aml/form?clientFormId=${clientFormId}&page=2`;
      // navigate('/kyc-aml/customer-list')
    } else {
      window.location.reload();
    }
  };
  // console.log(formAuthority)
  // console.log('formAuthority')

  return (
    <div className='max-w-6xl mx-auto'>
      {loading && <Loading />}
      <div className='max-w-6xl mx-auto mt-3 p-5 bg-white rounded-lg shadow-lg'>
        <h2 className='text-xl font-semibold mb-1'>KYC Form - {companyName} (Entity) </h2>
        {/* <h2 className="text-xl font-semibold mb-1">KYC Form - {companyName} (Entity, {formAuthority}) </h2> -> ADHOC TEMP REMOVAL OF MAS DISPLAY (.formAuthority), TO UNCOMMENT AND REMOVE THE ABOVE LINE */}
      </div>
      <div className={`max-w-6xl mx-auto mt-3 p-5 rounded-lg shadow-lg ${readOnly ? 'bg-gray-200' : 'bg-white '}`}>
        {/* 1st row */}
        <div className='grid grid-cols-2 gap-4 mb-4'>
          {/* <input maxLength={800} disabled={readOnly}Field type='text' name='entityName' displayName='Name of Entity' value={formData.entityName} handleInputChange={handleInputChange} /> */}
          <div>
            <label className='block font-medium text-gray-700 mb-1'>
              Name of Entity<i className='text-red-600'>*</i>
            </label>
            <input
              maxLength={800}
              disabled={readOnly}
              type='text'
              name='name'
              placeholder='Enter Entity Name'
              value={formData.name}
              onChange={handleInputChange}
              className='w-11/12 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
            />
            {mandatoryFieldError.name && <p style={{ color: 'red' }}>Please enter a name</p>}
          </div>
          <div>
            <label className='block font-medium text-gray-700 mb-1'>
              UEN Number / Company Identification Number<i className='text-red-600'>*</i>
            </label>
            <input
              maxLength={800}
              disabled={readOnly}
              type='text'
              id='uenNumber'
              name='uenNumber'
              placeholder='Enter UEN Number / Company Identification Number'
              value={formData.uenNumber}
              onChange={handleInputChange}
              className='w-11/12 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
            />
            {mandatoryFieldError.uenNumber && <p style={{ color: 'red' }}>Please enter UEN Number</p>}
          </div>
        </div>
        {/* 2nd row */}
        <div className='grid grid-cols-2 gap-4 mb-4'>
          <div>
            <p>
              {' '}
              Country of Incorporation <i className='text-red-600'>*</i>
            </p>
            <CountryList
              width={'w-11/12'}
              value={formData.incorporationCountry}
              name='incorporationCountry'
              handleInputChange={handleInputChange}
              disabled={readOnly}
            />
            {mandatoryFieldError.incorporationCountry && (
              <p style={{ color: 'red' }}>Please enter Country of Incorporation</p>
            )}
          </div>
          <div>
            <label htmlFor='incorporationDate' className='block font-medium text-gray-700 mb-1'>
              {' '}
              Date of Incorporation<i className='text-red-600'>*</i>
            </label>
            <input
              maxLength={800}
              disabled={readOnly}
              type='date'
              id='incorporationDate'
              value={formData.incorporationDate}
              name='incorporationDate'
              onChange={handleInputChange}
              className='w-11/12 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
            />
            {mandatoryFieldError.incorporationDate && <p style={{ color: 'red' }}>Please enter incorporation date</p>}
          </div>
        </div>
        {/* 3rd row */}
        <div className='grid grid-cols-2 gap-4 mb-4'>
          <div>
            <label className='block font-medium text-gray-700 mb-1'>
              Address of Registered Office<i className='text-red-600'>*</i>
            </label>
            <input
              maxLength={800}
              disabled={readOnly}
              type='text'
              id='registeredAddress'
              name='registeredAddress'
              placeholder='Enter Address of Registered Office'
              value={formData.registeredAddress}
              onChange={handleInputChange}
              className='w-11/12 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
            />
            {mandatoryFieldError.registeredAddress && <p style={{ color: 'red' }}>Please enter registered address</p>}
          </div>
          <div>
            <p>
              {' '}
              Country of Tax Residence<i className='text-red-600'>*</i>
            </p>
            <CountryList
              width={'w-11/12'}
              value={formData.taxResidenceCountry}
              name='taxResidenceCountry'
              handleInputChange={handleInputChange}
              disabled={readOnly}
            />
            {mandatoryFieldError.taxResidenceCountry && (
              <p style={{ color: 'red' }}>Please enter Country of Tax Residence</p>
            )}
          </div>
        </div>
        {/* 4th row */}
        <div className='grid grid-cols-2 gap-4 mb-4'>
          <div>
            <label htmlFor='email' className='block font-medium text-gray-700 mb-1'>
              Email
            </label>
            <input
              maxLength={800}
              disabled={readOnly}
              type='email'
              id='email'
              placeholder='Enter Email'
              value={formData.email}
              onChange={handleInputChange}
              name='email'
              className='w-11/12 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
            />
            {mandatoryFieldError.email && <p style={{ color: 'red' }}>Please enter a valid email address</p>}
          </div>
          <div>
            <p className='block font-medium text-gray-700 mb-1'>
              Is the Client listed in Rule 8(4) of the Rules?:<i className='text-red-600'>*</i>
              <a
                href='https://sso.agc.gov.sg/SL/LPA1966-S307-2015?DocDate=20170914&ProvIds=P12-#pr8-'
                target='_blank'
                rel='noopener noreferrer'
              >
                <CustomTooltip title='Legal Profession (Prevention of Money Laundering and Financing of Terrorism) Rules 2015 Rule 8(4)' />
              </a>
            </p>
            <div className='flex items-center'>
              <input
                type='radio'
                name='listedInRule84'
                value='yes'
                onChange={handleInputChange}
                checked={formData?.listedInRule84 === 'yes'}
                className='mr-1 w-4 h-4'
              />
              Yes
              <input
                type='radio'
                name='listedInRule84'
                value='no'
                onChange={handleInputChange}
                checked={formData?.listedInRule84 === 'no'}
                className='ml-2 mr-1 w-4 h-4'
              />
              No
            </div>
            {formData.listedInRule84 == 'yes' && (
              <input
                maxLength={800}
                disabled={readOnly}
                type='text'
                name='listedInRule84Reason'
                placeholder='Please describe this in more detail'
                value={formData?.listedInRule84Reason}
                onChange={handleInputChange}
                className='w-full mt-1 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
              />
            )}
          </div>
        </div>
        {decodedToken.companyId == 'Inspro_Insurance' && (
          <div className='grid grid-cols-2 gap-4 mb-4'>
            <div>
              <label htmlFor='contactNumber' className='block font-medium text-gray-700 mb-1'>
                Contact Number{' '}
              </label>
              <input
                maxLength={800}
                disabled={readOnly}
                type='tel'
                id='contactNumber'
                placeholder='Enter Contact Number'
                name='contactNumber'
                value={formData.contactNumber}
                onChange={handleInputChange}
                className='w-11/12 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
              />
              {mandatoryFieldError.contactNumber && <p style={{ color: 'red' }}>Please enter contact number</p>}
            </div>
          </div>
        )}
        {/* 5th row */}
        <div className='grid gap-4 mb-5 border-green-500 border p-2'>
          <div>
            <p className='block font-medium text-gray-700  py-1 px-2 underline'>
              All relevant parties {formData.listedInRule84 !== 'yes' && <i className='text-red-600'>*</i>}
            </p>
            {formData.listedInRule84 !== 'yes' && formData.connectedParty.length === 0 && (
              <p style={{ color: 'red' }}>
                Please add all directors and ultimate beneficial owners as relevant parties
              </p>
            )}
            <ConnectedOrBeneficialParty
              token={token}
              mandatoryConnectedFieldError={mandatoryConnectedFieldError}
              setMandatoryConnectedFieldError={setMandatoryConnectedFieldError}
              disabled={readOnly}
              personType='Relevant Party'
              formName='connectedParty'
              formData={formData}
              setFormData={setFormData}
              handleInputChange={handleInputChange}
              isValidEmail={isValidEmail}
              setIsValidEmail={setIsValidEmail}
              borderColor={'green'}
              listedInRule84={formData.listedInRule84}
            />
          </div>
        </div>

        {/* 6th Row */}
        <div className='grid gap-4'></div>

        {/* 7th row */}
        <div className='grid grid-cols-2 gap-4 mb-1.5'>
          <div>
            <div className='flex'>
              <span className='mr-2'> Source of Wealth</span>
              <Modal
                title='Definitions'
                token={token}
                CustomButton={() => (
                  <Tooltip
                    title={<p> Click to View definition/guidance </p>}
                    arrow
                    componentsProps={{
                      tooltip: {
                        sx: { maxWidth: '600px', fontSize: '14px' },
                      },
                    }}
                  >
                    <span className='text-xl relative bottom-0.5'> ⓘ </span>
                  </Tooltip>
                )}
              >
                <SourceOfWealth />
              </Modal>
            </div>
            <textarea
              maxLength={800}
              disabled={readOnly}
              name='sourceOfWealth'
              placeholder='Enter Source of Wealth'
              value={formData?.sourceOfWealth}
              onChange={handleInputChange}
              className='w-11/12 mb-3 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
              rows={3}
            />
            <div className='mb-3'>
              Form of Entity <i className='text-red-600'>*</i>
              <FormOfEntity formData={formData} handleInputChange={handleInputChange} disabled={readOnly} />
              {mandatoryFieldError?.formOfEntity && <p style={{ color: 'red' }}>Please choose</p>}
            </div>
          </div>

          <div>
            <div className='flex'>
              <span className='mr-2 mt-0.5'> Source of Funds</span>
              <Modal
                title='Definitions'
                token={token}
                CustomButton={() => <CustomTooltip title='Click to View definition/guidance' />}
              >
                <SourceOfFunds />
              </Modal>
            </div>
            <textarea
              maxLength={800}
              disabled={readOnly}
              name='sourceOfFunds'
              placeholder='Enter Source of Funds'
              value={formData?.sourceOfFunds}
              onChange={handleInputChange}
              className='w-11/12 mb-3 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
              rows={3}
            />
            {decodedToken.companyId == 'Inspro_Insurance' && (
              <>
                <label htmlFor='Account Manager' className='block font-medium text-gray-700 mb-1'>
                  Account Manager
                </label>
                <input
                  maxLength={800}
                  disabled={readOnly}
                  id='Account Manager'
                  placeholder='Enter Account Manager'
                  name='accountManager'
                  value={formData?.accountManager}
                  onChange={handleInputChange}
                  className='w-11/12 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
                />
              </>
            )}

            {formData?.formOfEntity?.includes('Others') && (
              <div>
                Others - Form of Entity
                <input
                  maxLength={800}
                  disabled={readOnly}
                  placeholder='Describe Form of Entity'
                  name='otherFormOfEntity'
                  value={formData?.otherFormOfEntity}
                  onChange={handleInputChange}
                  className='w-11/12 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
                />
              </div>
            )}
          </div>
        </div>

        {/* 8th row */}
        <div className='grid grid-cols-2 gap-4 mb-4'>
          <div>
            <div>
              <p>
                {' '}
                Company or Company Registry Profile<i className='text-red-600'>*</i>{' '}
              </p>
              {formData?.acraBusinessProfile && (
                <>
                  <a
                    href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${formData.acraBusinessProfile.split('/').slice(-1)[0]}&accessToken=${token}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-blue-600 mr-2'
                  >
                    {decodeURIComponent(formData?.acraBusinessProfile.split('/').slice(-1)[0])}
                  </a>
                  <span className='cursor-pointer' onClick={() => handleFileRemove('acraBusinessProfile')}>
                    {' '}
                    ❌{' '}
                  </span>
                </>
              )}
              <label className='cursor-pointer bg-gray-200 px-1 py-0.5 mt-1 rounded'>
                Browse
                <input
                  maxLength={800}
                  disabled={readOnly}
                  type='file'
                  name='acraBusinessProfile'
                  onChange={e => handleFileUpload(e, 'acraBusinessProfile')}
                  className='hidden'
                />
              </label>
              {mandatoryFieldError?.acraBusinessProfile && <p style={{ color: 'red' }}>Please choose</p>}
            </div>
          </div>
          <div>
            <p>
              {' '}
              Company Constitution (or Articles of Association) <i className='text-red-600'>*</i>
            </p>
            {formData?.companyConstitution && (
              <>
                <a
                  href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${formData.companyConstitution.split('/').slice(-1)[0]}&accessToken=${token}`}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-blue-600 mr-2'
                >
                  {decodeURIComponent(formData?.companyConstitution.split('/').slice(-1)[0])}
                </a>
                <span className='cursor-pointer' onClick={() => handleFileRemove('companyConstitution')}>
                  {' '}
                  ❌{' '}
                </span>
              </>
            )}
            <label className='cursor-pointer bg-gray-200 px-1 py-0.5 mt-1 rounded'>
              Browse
              <input
                maxLength={800}
                disabled={readOnly}
                type='file'
                name='companyConstitution'
                onChange={e => handleFileUpload(e, 'CompanyConstitutionLink')}
                className='hidden'
              />
            </label>
            {mandatoryFieldError?.companyConstitution && <p style={{ color: 'red' }}>Please choose</p>}
          </div>
        </div>

        {/* 9th row */}
        <div className='grid grid-cols-2 gap-4 mb-4'>
          <div className='mt-1'>
            <p> Other Document (Eg Organisation Chart, ACRA) </p>
            {formData?.organisationChart && (
              <>
                {Array.isArray(formData.organisationChart) ? (
                  // 如果是数组，显示所有文件
                  formData.organisationChart.map((file, index) => (
                    <div key={index} className='mb-2'>
                      <a
                        href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${file.split('/').slice(-1)[0]}&accessToken=${token}`}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-blue-600 mr-2'
                      >
                        {decodeURIComponent(file.split('/').slice(-1)[0])}
                      </a>
                      <span
                        className='cursor-pointer'
                        onClick={() => handleFileRemoveFromArray('organisationChart', index)}
                      >
                        {' '}
                        ❌{' '}
                      </span>
                    </div>
                  ))
                ) : (
                  // 如果是字符串，显示单个文件
                  <div>
                    <a
                      href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${formData.organisationChart.split('/').slice(-1)[0]}&accessToken=${token}`}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='text-blue-600 mr-2'
                    >
                      {decodeURIComponent(formData?.organisationChart.split('/').slice(-1)[0])}
                    </a>
                    <span className='cursor-pointer' onClick={() => handleFileRemove('organisationChart')}>
                      {' '}
                      ❌{' '}
                    </span>
                  </div>
                )}
              </>
            )}
            <label className='cursor-pointer bg-gray-200 px-1 py-0.5 mt-1 rounded'>
              Browse
              <input
                maxLength={800}
                disabled={readOnly}
                type='file'
                name='organisationChart'
                onChange={e => handleFileUpload(e, 'OrganizationChartLink')}
                className='hidden'
              />
            </label>
          </div>
          {/* {formAuthority === 'Law' && ( */}
          <div>
            <label className='font-medium text-gray-700'>
              Information on business relationship (Nature)<i className='text-red-600 ml-1 mr-1'>*</i>
            </label>
            <Modal
              title='Definitions'
              token={token}
              className='inline'
              CustomButton={() => <CustomTooltip title='Click to View definition/guidance' />}
            >
              <InformationPEP />
            </Modal>
            <textarea
              maxLength={800}
              disabled={readOnly}
              placeholder='Enter Information on Business Relationship'
              onChange={handleInputChange}
              name='businessRelationShip'
              value={formData.businessRelationShip}
              className='w-full p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
              rows={3}
            />
            {mandatoryFieldError?.businessRelationShip && <p style={{ color: 'red' }}>Please enter</p>}
          </div>
          {/* )} */}
        </div>

        {/* <div className="mt-1 p-2 flex items-center w-11/12">
        <p className='mr-2'> Is the Client a Ministry or department of the Singapore Government, an organ of the Singapore State or statutory board in Singapore; or a ministry or department of the government of a foreign country (Rule 6(3) of the Rules; PD 3.7)<i className='text-red-600'>*</i>
          <a href="https://sso.agc.gov.sg/SL/LPA1966-S307-2015?DocDate=20170914&ProvIds=P12-#pr6-" target="_blank" rel="noopener noreferrer">
            <CustomTooltip title='Legal Profession (Prevention of Money Laundering and Financing of Terrorism) Rules 2015 Rule 6(3)' />
          </a>
        </p>
        <input type="radio" name="governmentLinkedClient" value="yes" onChange={handleInputChange} checked={formData?.governmentLinkedClient === 'yes'} className="mr-1 w-4 h-4" />
        Yes
        <input type="radio" name="governmentLinkedClient" value="no" onChange={handleInputChange} checked={formData?.governmentLinkedClient === 'no'} className="ml-2 mr-1 w-4 h-4"/>
        No
      </div> */}
        {/* { formData.governmentLinkedClient == 'yes' && (
          <>
            <input maxLength={800} disabled={readOnly} type="text" name='governmentLinkedClientReason' placeholder="Please describe this relation" value={formData?.governmentLinkedClientReason} onChange={handleInputChange} className="w-full mt-1 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500" />
          </>
      )} */}
        {mandatoryFieldError?.listedInRule84 && <p style={{ color: 'red' }}>Please choose</p>}
        {/* <div className="mt-1 p-2 flex items-center w-11/12">
        <p className='mr-2'> IWhether to enable video verification?</p>
        <input type="radio" name="isvVideo" value="yes" onChange={handleInputChange} checked={formData?.isvVideo === 'yes'} className="mr-1 w-4 h-4" />
        Yes
        <input type="radio" name="isvVideo" value="no" onChange={handleInputChange} checked={formData?.isvVideo === 'no'} className="ml-2 mr-1 w-4 h-4"/>
        No
      </div> */}

        {/* Counterparties and Notes Section */}
        <div className='grid grid-cols-2 gap-4 mb-4'>
          {/* Counterparties Section */}
          <div>
            <CounterpartyManager
              formAuthority='Law'
              readOnly={readOnly}
              initialCounterparties={formData.counterparties || []}
              initialEnableCounterparties={formData.enableCounterparties || 'no'}
              onCounterpartiesChange={handleCounterpartiesChange}
              token={token}
              currentUrl={currentUrl}
            />
          </div>

          {/* Notes Section */}
          <div>
            <label className='font-medium text-gray-700'>Notes</label>
            <textarea
              maxLength={800}
              disabled={readOnly}
              placeholder='Enter Notes'
              onChange={handleInputChange}
              name='notes'
              value={formData.notes}
              className='w-11/12 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
              rows={3}
            />
          </div>
        </div>

        <br />
        <br />
        <br />
        {currentUrl !== '/form/kyc-aml' && !readOnly && (
          <div className='my-4 flex justify-between'>
            <button
              onClick={handleSaveForm}
              disabled={readOnly}
              className='ml-4 bg-green-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-green-600'
            >
              Save Form
            </button>

            {showSubmitButton && (
              <p>
                <Tooltip
                  title={
                    <p>
                      {' '}
                      This sends an email with a url to view this form in an external page, to the email field listed
                      above. <br /> After Sending Notification Email, this form can only be submitted via the external
                      form link.
                    </p>
                  }
                  arrow
                  componentsProps={{
                    tooltip: {
                      sx: { maxWidth: '445px', fontSize: '14px' },
                    },
                  }}
                >
                  <span className='text-xl relative bottom-0.5'> ⓘ </span>
                </Tooltip>

                <button
                  onClick={handleSendEmail}
                  disabled={readOnly}
                  className='ml-4 bg-green-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-green-600'
                >
                  Send Notification Email
                </button>

                {!formData?.emailSent ? (
                  <button
                    onClick={handleSubmitForm}
                    disabled={readOnly}
                    className='ml-4 bg-green-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-green-600'
                  >
                    Submit
                  </button>
                ) : (
                  <Tooltip
                    title={<p style={{ fontSize: '15px' }}>Email Notification sent, awaiting customer submission.</p>}
                    arrow
                    className='ml-4 bg-green-300 text-white font-semibold py-2 px-4 rounded-md '
                  >
                    <button onClick={handleSubmitForm} disabled={true} className='ml-4'>
                      {' '}
                      Submit{' '}
                    </button>
                  </Tooltip>
                )}
              </p>
            )}
          </div>
        )}

        {currentUrl === '/form/kyc-aml' && !readOnly && (
          <div className='my-4 flex justify-between'>
            {/* <button onClick={handleSaveForm} className='ml-4 bg-green-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-green-600'>
            Save Form
          </button> */}
            {showSubmitButton && (
              <p>
                {/* <button onClick={handleSubmitForm} className='ml-4 bg-green-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-green-600'>
                Submit
              </button> */}
                <button
                  onClick={handleSaveForm}
                  className='ml-4 bg-green-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-green-600'
                >
                  Save Form
                </button>
              </p>
            )}
          </div>
        )}
      </div>{' '}
      <br /> <br /> <br />
    </div>
  );
};
export default _EntityDetails;

const SourceOfWealth = () => {
  return (
    <div className='p-6 w-6xl'>
      <p>
        <strong> Source of wealth: </strong> Origin of the customer’s/beneficial owner’s entire body of wealth (total
        assets) and how it was acquired. Although you may not have information about assets that are not
        deposited/processed by you, it may be possible to obtain information from the customer, commercial databases or
        other open sources (evidence of title, copies of trust deeds, audited accounts, salary details, tax returns,
        bank statements etc.)
      </p>
    </div>
  );
};
const SourceOfFunds = () => {
  return (
    <div className='p-6 w-6xl'>
      <p>
        <strong> Source of funds: </strong> Origin of the funds or other assets which are the subject of the
        establishment of business relations (amount invested in/transferred to you etc.). You should not limit source of
        funds inquiry to the direct source from which the funds have been transferred, but also the activity that
        generated the funds. The information should be substantive and facilitate the establishment of the provenance of
        the funds (Salary payment, sale proceeds etc.)
      </p>
    </div>
  );
};

const NatureOfBusiness = ({ formData, handleInputChange, disabled }) => {
  return (
    <Tooltip title={formData?.natureOfBusiness?.split(' - ')[1]} leaveDelay={700} arrow>
      <select
        disabled={disabled}
        value={formData?.natureOfBusiness}
        onChange={handleInputChange}
        name='natureOfBusiness'
        className='w-11/12 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none mb-1 focus:border-green-500'
      >
        <option value=''> - Please Select - </option>
        <option value='Medium-Low - Accountants'>Accountants</option>
        <option value='Low - Approved Trustees'>Approved Trustees</option>
        <option value='High - Banks'>Banks</option>
        <option value='Medium-Low - Broker Dealers and Corporate Finance Advisory Firms'>
          Broker Dealers and Corporate Finance Advisory Firms
        </option>
        <option value='Medium-High - Casinos'>Casinos</option>
        <option value='Medium-High - Corporate Services Providers (CSPs)'>Corporate Services Providers (CSPs)</option>
        <option value='Low - Direct Life & Composite Insurers'>Direct Life & Composite Insurers</option>
        <option value='Medium-High - DPTSPs'>DPTSPs (Digital payment token service providers) </option>
        <option value='Medium-High - External Asset Managers (EAMs)'>External Asset Managers (EAMs)</option>
        <option value='Low - Finance Companies'>Finance Companies</option>
        <option value='Low - Financial Advisers'>Financial Advisers</option>
        <option value='Medium-Low - Fund Management Companies (excluding External Asset Managers)'>
          Fund Management Companies (excluding External Asset Managers)
        </option>
        <option value='Low - Insurance Brokers'>Insurance Brokers</option>
        <option value='Medium-High - Licensed Trust Companies (LTCs)'>Licensed Trust Companies (LTCs)</option>
        <option value='Medium-Low - Lawyers'>Lawyers</option>
        <option value='Medium-Low - Money Changers'>Money Changers</option>
        <option value='Medium-Low - Moneylenders'>Moneylenders</option>
        <option value='Low - Non-Bank Credit Card Companies'>Non-Bank Credit Card Companies</option>
        <option value='Medium-High - Payment Institutions WITH Cross Border Money Transfer Services'>
          Payment Institutions WITH Cross Border Money Transfer Services
        </option>
        <option value='Medium-Low - Payment Institutions WITHOUT Cross Border Money Transfers'>
          Payment Institutions WITHOUT Cross Border Money Transfers
        </option>
        <option value='Low - Pawnbrokers'>Pawnbrokers</option>
        <option value='Medium-High - Precious Stones and Precious Metals Dealers'>
          Precious Stones and Precious Metals Dealers
        </option>
        <option value='Medium-High - Real Estate Agents/Developers'>Real Estate Agents/Developers</option>
        <option value='Low - Securities Depository'>Securities Depository</option>
        <option value='Low - Others'>Others</option>
      </select>
    </Tooltip>
  );
};

const FormOfEntity = ({ formData, handleInputChange, disabled }) => {
  return (
    <Tooltip title={formData?.formOfEntity?.split(' - ')[1]} leaveDelay={700} arrow>
      <select
        disabled={disabled}
        value={formData?.formOfEntity}
        onChange={handleInputChange}
        name='formOfEntity'
        className='w-11/12 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none mb-1 focus:border-green-500'
      >
        <option value=''> - Please Select - </option>
        <option value='Express Trust'>Express Trust</option>
        <option value='Sole Proprietorship'>Sole Proprietorship</option>
        <option value='Partnership'>Partnership</option>
        <option value='Limited Partership'>Limited Partership</option>
        <option value='Limited Liability Partership'>Limited Liability Partership</option>
        <option value='Company'>Company</option>
        <option value='Others'>Other association or body of persons corporate or incorporate</option>
      </select>
    </Tooltip>
  );
};

const InformationPEP = () => {
  return (
    <div className='p-6 w-6xl'>
      <p>
        <strong>A business relationship</strong> refers to the purpose and intended nature of client relationship
        between the parties. Please describe the nature of services that is intended to be established. For example: •
        To receive legal advice on a property purchase. • To set up and manage a family trust. • To process payments for
        export and import of goods. • To obtain company secretarial services for my new business. • To hold client funds
        for a litigation settlement.
      </p>
    </div>
  );
};
